module.exports = __webpack_public_path__ + "media/images/bank_images/bando_de_brasilia-5350978a21ec9346f1332f76cb1d33a7.png";